import { useCallback } from 'react'
import { create } from 'zustand'

/** Which surface the Průzkum page shows. */
export type SearchMode = 'search' | 'research'

interface SearchModeState {
  /** Selected mode per case id. In-memory — survives navigation within the
   * session (e.g. opening a run and returning), resets on a full reload. */
  modeByCase: Record<string, SearchMode>
  setMode(caseId: string, mode: SearchMode): void
}

const useSearchModeStore = create<SearchModeState>()(set => ({
  modeByCase: {},
  setMode(caseId, mode) {
    set(state =>
      state.modeByCase[caseId] === mode
        ? state
        : { modeByCase: { ...state.modeByCase, [caseId]: mode } }
    )
  },
}))

/** Read + set the Průzkum mode for a case. Defaults to `'search'`. */
export function useSearchMode(caseId: string): [SearchMode, (mode: SearchMode) => void] {
  const mode = useSearchModeStore(s => s.modeByCase[caseId] ?? 'search')
  const set = useSearchModeStore(s => s.setMode)
  const setMode = useCallback((m: SearchMode) => set(caseId, m), [set, caseId])
  return [mode, setMode]
}
